module.exports = __webpack_public_path__ + "static/project-9b-774f0341d478d573ca923f1c13b522b1.png";